import {Component, OnInit, Input, ViewChild} from '@angular/core';
import {CodeInputComponent} from 'angular-code-input';
import {LoadingController, ModalController} from '@ionic/angular';
import {presentLoader} from '../../util/ion-util';
import { Logger } from '../../util/logger/logger.service';

@Component({
    selector: 'app-verification-code-modal',
    templateUrl: './verification-code-modal.component.html',
    styleUrls: ['./verification-code-modal.component.scss'],
})
export class VerificationCodeModalComponent implements OnInit {
    @Input()
    caller?: string;
    @Input()
    headerText: string;
    @Input()
    bodyText: string[];
    @Input()
    errorText?: string[];
    @Input()
    codeCompletedCallback: CodeCompletedCallback;
    @Input()
    loaderTimeout = 30000;

    error: any;

    @ViewChild('codeInput')
    codeInput: CodeInputComponent;

    constructor(
        private modalCtrl: ModalController,
        private loadingCtrl: LoadingController,
        private logger: Logger,
    ) {
    }

    ngOnInit() {
    }

    async onDismiss() {
        await this.modalCtrl.dismiss();
    }

    // this called only if user entered full code
    async onCodeCompleted(code: string) {
        const loader = await presentLoader(this.loadingCtrl, this.loaderTimeout);
        try {
            await this.codeCompletedCallback(code);
            await loader.dismiss();
            await this.modalCtrl.dismiss();
        } catch (error) {
            await loader.dismiss();
            this.logger.error(error);
            this.error = true;
            this.codeInput.reset();
            this.codeInput.focusOnField(0);
        }
    }
}

type CodeCompletedCallback = (code: string) => Promise<any>;
